import React from "react";
import Papa from "papaparse";

const CSVExportButton = ({
  sessionData,
  type = "result",
  filename = "session_result.csv",
}) => {
  const generateCSV = () => {
    if (!sessionData) return "";

    let fullCSV = "";
    if (type === "result") {
      // Step-by-step force
      const stepRows = sessionData.leftForceArray.map((left, i) => ({
        Step: i + 1,
        "Left Force": left,
        "Right Force": sessionData.rightForceArray[i] || 0,
      }));

      // Summary row
      stepRows.push({
        Step: "Average",
        "Left Force": sessionData.avgLeftForce,
        "Right Force": sessionData.avgRightForce,
      });

      const stepCSV = Papa.unparse(stepRows);

      // Additional metrics
      const metrics = [
        { Metric: "Step Count", Value: sessionData.stepCount },
        { Metric: "Step Time", Value: sessionData.stepTime },
        { Metric: "Accuracy", Value: sessionData.accuracy },
      ];

      const metricsCSV = Papa.unparse(metrics);
      fullCSV = `${stepCSV}\n\n${metricsCSV}`;
    } else if (type === "history") {
      filename = "history_report";
      const historyRows = Object.entries(sessionData.history).map(
        ([date, session]) => ({
          Date: date,
          "Peak Left Force": session.peakLeftForce,
          "Peak Right Force": session.peakRightForce,
          "Average Left Force": session.avgLeftForce,
          "Average Right Force": session.avgRightForce,
          "Left Hip Pain": session.leftHip,
          "Right Hip Pain": session.rightHip,
          "Left Knee Pain": session.leftKnee,
          "Right Knee Pain": session.rightKnee,
          "Left Ankle Pain": session.leftAnkle,
          "Right Ankle Pain": session.rightAnkle,
        })
      );

      fullCSV = Papa.unparse(historyRows);
    }
    const blob = new Blob([fullCSV], { type: "text/csv;charset=utf-8;" });
    const isChrome =
      /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);

    if (isChrome) {
      // Fallback to base64 href in Chrome
      const encodedUri =
        "data:text/csv;charset=utf-8," + encodeURIComponent(fullCSV);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      // Blob method for browsers like Safari, Firefox
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }
  };

  return (
    <button className="button1 white h3" onClick={generateCSV}>
      Export to CSV
    </button>
  );
};

export default CSVExportButton;
